<div class="task-nav" *ngIf="TaskNav">
    <div class="lesson-title">
        <h3 [routerLink]="['/theory', TaskNav.id]">{{TaskNav.name}}</h3>
        <div class="lesson-progress">
            {{CompletedTasks(TaskNav.tasks)}}/{{TaskNav.tasks.length}}
        </div>
    </div>
    <div class="lesson-nav">
        <div class="nav-block" *ngFor="let taskNav of TaskNav.tasks; let i = index"
        [routerLink]="['/courses', course_id, 'run', taskNav.id]"
        >
            <div class="line-progress" [ngClass]="{'full': taskNav.completed == 1}">
                <span class="task-name">{{i+1}}. {{taskNav.name}}</span>
            </div>
        </div>
    </div>
</div>
<div class="block-page-title">
    <h2 class="page-title" *ngIf="task.name">{{task.name}}</h2>
</div>
<div class="row jcsb">
    <div class="col-6">
        <div class="description"  *ngIf="task.information">
            {{task.information}}
        </div>
        <div class="task-buttons" *ngIf="TaskNav">
            <div *ngIf="PrevTask(TaskNav.tasks)" [routerLink]="['/courses', course_id, 'run', PrevTask(TaskNav.tasks)]" class="prev-lesson button-purple-light-nofill">
                Предыдущее задание
            </div>
            <div *ngIf="NextTask(TaskNav.tasks)" [routerLink]="['/courses', course_id, 'run', NextTask(TaskNav.tasks)]" class="next-lesson button-purple-light-fill">
                Следующее задание
            </div>
        </div>
    </div>
    <div class="col-6">
        <ng-container *ngIf="task.technology=='form'; then formblock else codeblock"></ng-container>
        
        <ng-template #formblock>
            <ng-container *ngIf="mySchema.properties">
                <div class="form code">
                    <div class="code-title">
                        Ответьте на вопросы
                    </div>
                    <sf-form [schema]="mySchema" [formControl]="query">
                    </sf-form>
                </div>
            </ng-container>
        </ng-template>

        <ng-template #codeblock>
            <div class="form code">
                <div class="code-title">
                    Код
                </div>
                <ngx-codemirror [formControl]="query" 
                [options]="{
                    lineNumbers: true,
                    theme: 'duotone-light',
                    mode: task.notepadmode
                }"></ngx-codemirror>
            </div>
        </ng-template>
        
        <div class="response" [ngClass]="{'': correctly == 0, 'right': correctly == 1, 'error': correctly === 2}">
            <div class="response-block">
                <div class="response-title">
                    Результат
                </div>
                {{response.resulttext}}
                
                <ng-container *ngIf="response.resulttype == '0'; then tableanswer else stringanswer" ></ng-container>
                 
                <!--Ответ таблицей-->
                <ng-template #tableanswer>
                        <table mat-table [dataSource]="TableRows" >
                            <ng-container *ngFor="let column of displayedColumns;">
                                <ng-container  matColumnDef="{{column}}">
                                    <th mat-header-cell *matHeaderCellDef> {{column | uppercase}} </th>
                                    <td mat-cell *matCellDef="let row"> {{row[column]}} </td>
                                </ng-container>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                </ng-template>

                    <!--Ответ строкой-->
                <ng-template #stringanswer>
                    <ng-container *ngIf="response.resultcontent;">
                        <span style="white-space: pre-line">{{response.resultcontent.text}}</span>
                    </ng-container>
                </ng-template>
               
            </div>
            <div class="response-button">
                <button (click)="runCheck(query.value)" title="Выполнить код"></button>
            </div>
            
        </div>
    </div>
</div>

